import React from 'react';
import { useTranslation } from 'react-i18next';
import rotateIcon from '../../assets/rotate-block/rotate.svg';
import './RotateOverlay.css';

const RotateOverlay = ({ show, hideSubtitle }) => {
  const { t } = useTranslation();

  if (!show) return null;

  return (
    <div className="rotate-screen-modal-overlay">
      <div className="rotate-screen-modal-box">
        <div className="rotate-screen-icon-container">
          <img src={rotateIcon} alt="Rotate device" className="rotate-screen-icon" />
        </div>
        <div className="rotate-screen-text-container">
          <p className="rotate-screen-message">{t('ROTATE_DEVICE_MESSAGE')}</p>
          {!hideSubtitle && <p className="rotate-screen-subtitle">{t('LANDSCAPE_VIEW')}</p>}
        </div>
      </div>
    </div>
  );
};

export default RotateOverlay;
